<div class="change-event-justification">
    <app-popup-top-line></app-popup-top-line>
    <div class="change-event-justification-header">
        <div class="title">Add Justification</div>
        <img style="cursor: pointer" src="assets/images/common/cancel.svg" (click)="closeClick()" />
    </div>
    <div class="change-event-justification-body">
        <div class="input-title">Enter justification content</div>
        <div class="textarea">
            <textarea type="text" maxlength="250" [formControl]="justificationContentFormControl" placeholder="Content"></textarea>
        </div>
    </div>
    <div class="change-event-justification-footer">
        <button class="cancel" (click)="closeClick()">{{ "common.cancel" | labelsProvider}}</button>
        <button
            class="confirm"
            [ngClass]="{'confirm-disabled': justificationContentFormControl.invalid}"
            (click)="addJustification()"
            cdkFocusInitial>
            <span>{{ "violationPage.addJustificationButton" | labelsProvider}}</span>
        </button>
    </div>
</div>
